/* eslint-disable jsx-a11y/anchor-is-valid */
import { MenuComponent } from '_metronic/assets/ts/components'
import { KTSVG } from '_metronic/helpers'
import clsx from 'clsx'
import { useEffect } from 'react'

interface Prop {
  id: any
  customClicker?: any
  onClickView?: (id: any) => void
  onClickScanQrCode?: (id: any) => void
  onClickDelete?: (id: any) => void
  onClickPrintLabel?: (id: any) => void
  hideScan?: boolean
  hidePrintLabel?: boolean
  hideDownloadFile?: boolean
  hideDelete?: boolean
  onDownloadFile?: (id: any) => void
  onUploadFile?: (id: any) => void
}

const CustomShippingItemAction: React.FC<Prop> = ({
  id,
  onClickView,
  onClickScanQrCode,
  onClickDelete,
  onClickPrintLabel,
  hideScan,
  hidePrintLabel,
  hideDownloadFile,
  hideDelete,
  onDownloadFile,
  onUploadFile,
}) => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  return (
    <>
      <a
        className='btn btn-icon btn-custom btn-active-light rounded-circle'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        // data-kt-menu-target={`#${customClicker}`}
      >
        <img src='/media/icons/dots-vertical.png' alt='Dot Vertical Icon' width={20} height={20} />
      </a>
      {/* begin::Menu */}

      <div
        className={clsx(
          'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4'
        )}
        data-kt-menu='true'>
        {/* begin::Menu item */}

        {/* begin::Menu item */}

        {!hideScan && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickScanQrCode) {
                  onClickScanQrCode(id)
                }
              }}>
              <img
                className='me-2'
                src='/media/icons/duotune/files/fil024.svg'
                alt=' Icon'
                width={20}
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                สแกน QR Code
              </div>
            </a>
          </div>
        )}

        {/* end::Menu item */}

        {/* begin::Menu item */}

        {!hidePrintLabel && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => {
                if (onClickPrintLabel) {
                  onClickPrintLabel(id)
                }
              }}>
              <img
                className='me-2'
                src='/media/icons/duotune/files/fil003.svg'
                alt=' Icon'
                width={20}
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                พิมพ์
              </div>
            </a>
          </div>
        )}

        {/* end::Menu item */}

        <div className='menu-item px-3' data-kt-menu-dismiss='true'>
          <a
            className='menu-link px-3'
            onClick={() => {
              if (onClickView) {
                onClickView(id)
              }
            }}>
            <div className='d-flex flex-row align-items-center'>
              <img className='me-2' src='/media/icons/eye-grey.svg' alt='Edit Icon' width={20} />{' '}
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ดูรายละเอียด
              </div>
            </div>
          </a>
        </div>

        {/* end::Menu item */}

        {/* begin::Menu item */}

        {!hideDelete && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3'
              onClick={() => {
                if (onClickDelete) {
                  onClickDelete(id)
                }
              }}>
              <div className='d-flex flex-row align-items-center'>
                <img className='me-2' src='/media/icons/delete.svg' alt='Delete Icon' width={20} />{' '}
                <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                  ลบ
                </div>
              </div>
            </a>
          </div>
        )}

        {/* end::Menu item */}

        <div className='menu-item px-3' data-kt-menu-dismiss='true'>
          <a
            className='menu-link px-3'
            onClick={() => {
              if (onUploadFile) {
                onUploadFile(id)
              }
            }}>
            <div className='d-flex flex-row align-items-center'>
              <KTSVG path='/media/icons/duotune/files/fil005.svg' className='svg-icon-2 me-2' />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                อัพโหลดไฟล์แนบ
              </div>
            </div>
          </a>
        </div>

        {!hideDownloadFile && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3'
              onClick={() => {
                if (onDownloadFile) {
                  onDownloadFile(id)
                }
              }}>
              <div className='d-flex flex-row align-items-center'>
                <KTSVG path='/media/icons/duotune/files/fil013.svg' className='svg-icon-2 me-2' />
                <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                  ดาวน์โหลดไฟล์แนบ
                </div>
              </div>
            </a>
          </div>
        )}
      </div>
      {/* end::Menu */}
    </>
  )
}

export default CustomShippingItemAction
